import { render, staticRenderFns } from "./card-user.vue?vue&type=template&id=5f6fae8c&scoped=true"
import script from "./card-user.vue?vue&type=script&lang=js"
export * from "./card-user.vue?vue&type=script&lang=js"
import style0 from "./card-user.vue?vue&type=style&index=0&id=5f6fae8c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6fae8c",
  null
  
)

export default component.exports